<mat-card>
    <mat-card-header>
        <mat-card-title class="mat-card-title-custom">{{'title.processing_contract' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'enterprise_contract.ttl_search' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form #myForm="ngForm" class="pb-3">
                    <div class="row">
                        <!-- Mã hợp đồng -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractCode = documents.contractCode == undefined ? '' : (documents.contractCode + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.doc_code' | translate"
                                    name="contractCode" [(ngModel)]="documents.contractCode" maxlength="255"
                                    autocomplete="off">
                                <button mat-button *ngIf="documents.contractCode" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractCode=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Loại hợp đồng -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                              <mat-label>{{'form.service_type' | translate}}</mat-label>
                              <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                                          (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType"
                                          [disabled]="!myForm.valid" name="serviceType" [(ngModel)]="documents.serviceType"
                                          (ngModelChange)="onSearch(0, paginate.pageSize)">
                                <mat-option>
                                  <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                                         [placeholderLabel]="'search_form.search' | translate"
                                                         [formControl]="serviceTypesFilterCtrl">
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option value="null" selected
                                            (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                                  {{'form.select_all' | translate}}
                                </mat-option>
                                <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                                  <i class="fa fa-circle-o-notch fa-spin"></i>
                                </div>
                                <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                                            (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                                  {{serviceType.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="col-md-6 col-lg-4">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.processing_progress' | translate}}</mat-label>
                                <mat-select #statusSelect (focusout)="(checkFocus = true)" 
                                    (selectionChange)="checkFocus = false" [(ngModel)]="documents.status" (ngModelChange)="onClickBtnFilter()"
                                    (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status"
                                    name="status">
                                    <mat-option selected
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'form.select_all' | translate}}</mat-option>
                                    <mat-option [value]="1"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}</mat-option>
                                    <mat-option [value]="2"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}</mat-option>
                                    <mat-option [value]="3"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.signing' | translate}}</mat-option>
                                    <mat-option [value]="4"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling' | translate}}</mat-option>
                                    <mat-option [value]="5"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.approving' | translate}}</mat-option>
                                    <mat-option *ngIf="entType == 2" [value]="6"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_information_signed.enterprise_status.processing' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Tên người thực hiện  -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.userName = documents.userName == undefined ? '' : (documents.userName + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.performerName' | translate"
                                    name="userName" [(ngModel)]="documents.userName" maxlength="255" autocomplete="off">
                                <button mat-button *ngIf="documents.userName" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.userName=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Số điện thoại -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.phone = documents.phone == undefined ? '' : (documents.phone + '').trim()"
                                    #focusInput matInput [placeholder]="'headertable.phone' | translate" name="phone" (keypress)="allowOnlyNumbersAndSpace($event)"
                                    [(ngModel)]="documents.phone" maxlength="15" autocomplete="off">
                                <button mat-button *ngIf="documents.phone" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.phone=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Email người thực hiện  -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.email = documents.email == undefined ? '' : (documents.email + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.performerEmail' | translate"
                                    name="email" [(ngModel)]="documents.email" maxlength="255" autocomplete="off">
                                <button mat-button *ngIf="documents.email" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.email=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Trạng thái link ký -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'searchDocumentMine.lbl_link_sign_status' | translate}}</mat-label>
                                <mat-select #linkSignStatusSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, linkSignStatusSelect)" id="linkSignStatus"
                                    name="linkSignStatus" [(ngModel)]="documents.linkSignStatus"
                                    (ngModelChange)="onClickBtnFilter()">
                                    <mat-option [value]="''" selected
                                        (click)="this.commonService.closeDropdownList(this.linkSignStatusSelect)">
                                        {{'form.select_all' | translate}}</mat-option>
                                    <mat-option [value]="linkSignStatusEnum.VALID"
                                        (click)="this.commonService.closeDropdownList(this.linkSignStatusSelect)">
                                        {{'searchDocumentMine.linkSignStatusValue.valid' | translate}}</mat-option>
                                    <mat-option [value]="linkSignStatusEnum.EXPIRED"
                                        (click)="this.commonService.closeDropdownList(this.linkSignStatusSelect)">
                                        {{'searchDocumentMine.linkSignStatusValue.expired' | translate}}</mat-option>
                                    <mat-option [value]="linkSignStatusEnum.NOT_APPLICABLE"
                                        (click)="this.commonService.closeDropdownList(this.linkSignStatusSelect)">
                                        {{'searchDocumentMine.linkSignStatusValue.not_applicable' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian nhận (từ ngày) -->
                        <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.dateRequest' | translate }}</mat-label>
                                <input matInput [matDatepicker]="receivedAt" [max]="maxDate"
                                    #receivedAtCtrl="ngModel"
                                    (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['receivedAt'])"
                                    name="receivedAt" #pickerInput [(ngModel)]="documents.receivedAt" maxlength="200"
                                    (focus)="createdDateErr = 'fromDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="receivedAt">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #receivedAt></mat-datepicker>
                                <mat-error *ngIf="receivedAtCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error *ngIf="receivedAtCtrl?.errors?.matDatepickerMax">
                                    {{ 'search_form.received_date_from' | translate }}
                                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                                    {{ 'search_form.received_date_to' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Tên hợp đồng-->
                        <div class="col-lg-4 col-md-6"  *ngIf="!isBasicSearchForm">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractName = documents.contractName == undefined ? '' : (documents.contractName + '').trim()"
                                    matInput [placeholder]="'form.doc_name' | translate" name="contractName"
                                    [(ngModel)]="documents.contractName" maxlength="255" autocomplete="off">
                                <button mat-button *ngIf="documents.contractName" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractName=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- button up/down -->
                        <div class="col-lg-12 col-md-6 d-flex justify-content-end">
                            <button *ngIf="!isBasicSearchForm" type="button" mat-button class="advance-search"
                                (click)="onCloseAdvancedSearchForm()">
                                <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                                <em class="material-icons">keyboard_arrow_up</em>
                            </button>
                            <button *ngIf="isBasicSearchForm" type="button" mat-button class="advance-search"
                                (click)="onExpandAdvancedSearchForm()">
                                <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                                <em class="material-icons">keyboard_arrow_down</em>
                            </button>
                        </div>
                    </div>



                    <!-- button tìm kiếm -->
                    <div class="row mt-3">
                        <div class="col-lg-12 d-flex justify-content-center">
                            <button mat-stroked-button color="primary" type="button" (click)="onClickBtnFilter()"
                                [disabled]="!myForm.valid || isTableLoading">
                                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                                {{'enterprise_contract.buttons.search' | translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>

        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-panel-title
                    class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center list-title">
                    <div class="title col-xs-12 pl-0">
                        <span>{{'enterprise_contract.list_processing_contract' | translate}} ({{paginate.totalRow}})
                        <span  *ngIf="!commonService.getIsLockedEnterprise()">,&nbsp;{{'enterprise_contract.selected' | translate}}
                            {{selection.selected.length}}</span>
                        </span>
                    </div>
                    <div class="buttonMD">
                        <button class="btn1-mine"  style="position: absolute; right: 24px;" mat-stroked-button color="primary" type="button"
                                [matMenuTriggerFor]="menuFeature">
                            <mat-icon>apps</mat-icon>
                            {{'button.more_feature' | translate}}
                        </button>
                    </div>
                    <mat-menu #menuFeature="matMenu" >
                            <button mat-menu-item (click)="notifyLot()" [disabled]="selection.selected.length === 0 || this.dataSource === null || this.dataSource.data === null
                                    || this.dataSource.data.value === null || this.dataSource.data.value.length === 0"
                                    [ngClass]="{'other-button': selection.selected.length !== 0}">
                                <i 
                                    class="fa fa-bell-o fa-fw vt-cursor-pointer mr-1" aria-hidden="true"
                                    style="font-size: 1rem;"
                                    matTooltip="{{'enterprise_customer_management.buttons.notify_sign_contract' | translate}}"
                                    [ngClass]="{'other-button': selection.selected.length !== 0}">
                                </i>
                                <span>{{'enterprise_customer_management.buttons.notify_sign_contract' |
                                    translate}}</span>
                            </button>
                            <button mat-menu-item class="other-button"
                                    *ngIf="!commonService.getIsLockedEnterprise()" style="border-bottom: 1px solid rgb(213 213 213) !important;"
                                    (click)=" $event.stopPropagation()"  [matMenuTriggerFor]="menuColumn">
                                <mat-icon class="mr-0 other-button">more_vert</mat-icon>
                                {{'bodytable.status_column' | translate}}
                            </button>
                    </mat-menu>
                    <mat-menu #menuColumn="matMenu">
                        <mat-checkbox style="margin: 0px 15px" [(ngModel)]="isCheckedAllColumn" (click)="$event.stopPropagation()" (change)="onAllColumnCheckboxChange(isCheckedAllColumn)"
                        >{{ 'form.select_all_group' | translate}}</mat-checkbox>
                        <div *ngFor="let option of columnDefinitions">
                            <mat-checkbox style="margin: 0px 15px" [(ngModel)]="option.default" (change)="onCheckboxChange(option)" (click)="$event.stopPropagation()"
                                        [checked]="option.default" *ngIf="!option.check"
                            >{{ option.name | translate}}</mat-checkbox>
                        </div>
                    </mat-menu>
                </mat-panel-title>
                <div class="mat-table-container" style=" display: block; max-height: 590px">
                    <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                        class="mat-table-col-extra-sm" [ngStyle]="{'min-width': tableWidth + 'px'}">
                        <!-- select -->
                        <ng-container matColumnDef="select">
                            <mat-header-cell *matHeaderCellDef
                                            class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                            <mat-checkbox
                                *ngIf="dataSource && dataSource.data && dataSource.data.value && dataSource.data.value.length > 0"
                                (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                color="primary"></mat-checkbox>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                                    (click)="$event.stopPropagation()">
                            <mat-checkbox
                                color="primary"
                                (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(element.idNotify) : null;addListRecord($event.checked,element)"
                                [checked]="selection.isSelected(element.idNotify)"
                            >
                            </mat-checkbox>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell check-col">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- STT -->
                        <ng-container matColumnDef="STT">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                {{'enterprise_contract.table_headers.No' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                {{element.STT}}
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- Mã hd -->
                        <ng-container matColumnDef="contractCode">
                            <mat-header-cell *matHeaderCellDef style="width: 20%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'search_form.doc_code' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom"
                                style="width: 20%;">
                                <span (click)="$event.stopPropagation()" matTooltip="{{element.contractCode}}"
                                    class="fix-width" style="margin-left: -5px;">
                                    {{element.contractCode}}
                                </span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- Loại hợp đồng -->
                        <ng-container matColumnDef="serviceType">
                            <mat-header-cell *matHeaderCellDef style="width: 20%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'form.service_type' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom"
                                style="width: 20%;">
                                <span (click)="$event.stopPropagation()" matTooltip="{{element.serviceTypeName}}"
                                    class="fix-width" style="margin-left: -5px;">
                                    {{element.serviceTypeName}}
                                </span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- Tên hd -->
                        <ng-container matColumnDef="contractName">
                            <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'form.doc_name' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.contractName }}"
                                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                                style="max-width: 30%;">
                                <span class="fix-width">{{ element.contractName }}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 30%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- Tên người thực hiện -->
                        <ng-container matColumnDef="userName">
                            <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'search_form.performerName' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.name }}"
                                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                                style="max-width: 15%;">
                                <span class="fix-width">{{ element.name }}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 15%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- Số điện thoại -->
                        <ng-container matColumnDef="phone">
                            <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                <span>
                                    {{'headertable.phone' | translate}}
                                </span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                                matTooltip="{{element.phone}}" class="mat-cell-non-boder-right-bottom"
                                style="max-width: 15%;">
                                <span class="fix-width">{{ element.phone }}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 15%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- Email người gửi -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 11%;">
                                {{'search_form.performerEmail' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" [matTooltip]="element.email"
                                class="mat-cell-non-boder-right-bottom number-cell-center"
                                (click)="$event.stopPropagation()" style="max-width: 11%;">
                                <span class="fix-width">{{ element.email }}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 11%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- Trạng thái link ký -->
                        <ng-container matColumnDef="linkSignStatus">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 10%;">
                                {{'searchDocumentMine.lbl_link_sign_status' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                                style="max-width: 10%;"
                                (click)="$event.stopPropagation()">
                                <nz-tag *ngIf="element.linkSignStatus === linkSignStatusEnum.VALID" [nzColor]="'green'"
                                    style="margin-right: 0px;">{{'searchDocumentMine.linkSignStatusValue.valid' | translate}}</nz-tag>
                                <nz-tag *ngIf="element.linkSignStatus === linkSignStatusEnum.EXPIRED" [nzColor]="'red'"
                                    style="margin-right: 0px;">{{'searchDocumentMine.linkSignStatusValue.expired' | translate}}</nz-tag>
                                <nz-tag *ngIf="element.linkSignStatus === linkSignStatusEnum.NOT_APPLICABLE" style="margin-right: 0px;">
                                    {{'searchDocumentMine.linkSignStatusValue.not_applicable' | translate}}</nz-tag>
                            </mat-cell>
                        </ng-container>

                        <!-- Ngày hết hạn link ký -->
                        <ng-container matColumnDef="linkExpiredDate">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 11%;">
                                {{'searchDocumentMine.lbl_link_expired_date' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-cell-non-boder-right-bottom number-cell-center"
                                (click)="$event.stopPropagation()" style="max-width: 11%;">
                                <span class="fix-width" *ngIf="element.linkSignStatus === linkSignStatusEnum.NOT_APPLICABLE || !element.linkExpireTime">--</span>
                                <span class="fix-width" *ngIf="element.linkSignStatus !== linkSignStatusEnum.NOT_APPLICABLE && element.linkExpireTime" matTooltip="{{ element.linkExpireTime | dateformat }}">{{ element.linkExpireTime | dateformat}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- Ngày nhận yêu cầu -->
                        <ng-container matColumnDef="receivedAt">
                            <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                <span>
                                    {{'search_form.dateRequest' | translate}}
                                </span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.receivedAt | dateformat}}"
                                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                                style="max-width: 10%;">
                                <span class="fix-width">{{ element.receivedAt | dateformat}}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>
                        <ng-container matColumnDef="contractStatus">
                            <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                                             style="max-width: 10%;">
                              {{'enterprise_contract.table_headers.document_status' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                      class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                                      style="max-width: 10%;"
                                      (click)="$event.stopPropagation()">
                              <nz-tag *ngIf="element.contractStatus === enumContractStatus.DRAFT" style="margin-right: 0px;">
                                {{'search_form.draft' | translate}}</nz-tag>
                              <nz-tag *ngIf="element.contractStatus === enumContractStatus.PROCESSING" [nzColor]="'blue'"
                                      style="margin-right: 0px;">{{'search_form.processing' | translate}}
                              </nz-tag>
                              <nz-tag *ngIf="element.contractStatus === enumContractStatus.REJECTED" [nzColor]="'red'"
                                      style="margin-right: 0px;">{{'search_form.denied_sign' | translate}}
                              </nz-tag>
                              <nz-tag *ngIf="element.contractStatus === enumContractStatus.FINISHED" [nzColor]="'green'"
                                      style="margin-right: 0px;">{{'search_form.finish' | translate}}</nz-tag>
                              <nz-tag *ngIf="element.contractStatus === enumContractStatus.CANCELLED" [nzColor]="'red'"
                                      style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                              <nz-tag *ngIf="element.contractStatus == enumContractStatus.CONNECTING" [nzColor]="'blue'"
                                      style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
                              <nz-tag *ngIf="element.contractStatus == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                                      class='wait-confirm-enterprice-no-moit__tag'
                                      style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>
                              <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                                *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                                <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                                </nz-badge>
                                <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                                </nz-badge>
                                <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                                </nz-badge>
                              </div> -->
                              <div *ngIf="element.identifyStatus == 3" style="font-size: 16px;"
                                   [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"
                                   class="d-flex align-items-center" nz-tooltip
                                   nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">
                                <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                              </div>
                              <div *ngIf="element.identifyStatus == 4" style="font-size: 16px;"
                                   [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"
                                   class="d-flex align-items-center" nz-tooltip
                                   nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">
                                <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                              </div>
                              <div *ngIf="element.identifyStatus == 5" style="font-size: 16px;"
                                   [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"
                                   class="d-flex align-items-center" nz-tooltip
                                   nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">
                                <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                              </div>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>
                        <!-- Trạng thái xử lý -->
                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                                style="max-width: 10%;">
                                {{'search_form.processing_progress' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                                style="max-width: 10%;" (click)="$event.stopPropagation()">
                                <nz-tag *ngIf="element.status == 1" [nzColor]="'orange'">
                                    {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}</nz-tag>
                                <nz-tag *ngIf="element.status == 2" [nzColor]="'blue'">
                                    {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}</nz-tag>
                                <nz-tag *ngIf="element.status == 3" [nzColor]="'blue'">
                                    {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.signing' | translate}}</nz-tag>
                                <nz-tag *ngIf="element.status == 4" [nzColor]="'blue'">
                                    {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling' | translate}}</nz-tag>
                                <nz-tag *ngIf="element.status == 5" [nzColor]="'blue'">
                                    {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.approving' | translate}}</nz-tag>
                                <nz-tag *ngIf="element.status == 6" [nzColor]="'blue'">
                                    {{'enterprise_contract.panel_document_view.table_information_signed.enterprise_status.processing' | translate}}</nz-tag>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- người thực hiện -->
                        <ng-container matColumnDef="numberOtpConfig">
                            <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                <span>
                                    {{'search_form.number_SMS_OTP_configured' | translate}}
                                </span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ getOTP(element,element.numberOtpConfig) }}"
                                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                                style="max-width: 7%;">
                                <span class="fix-width">{{ getOTP(element,element.numberOtpConfig) }}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 7%; justify-content: center;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- vai trò -->
                        <ng-container matColumnDef="numberOtpUsed">
                            <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                <span>
                                    {{'search_form.number_SMS_OTP_used' | translate}}
                                </span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{getOTP(element,element.numberOtpUsed)}}"
                                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                                style="max-width: 7%;">
                                <span class="fix-width">{{ getOTP(element,element.numberOtpUsed) }}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 7%; justify-content: center;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- nguoi lap -->
                        <ng-container matColumnDef="numberOtpRemain">
                            <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'search_form.number_SMS_OTP_remaining' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ getOTP(element,element.numberOtpRemain) }}"
                                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                                style="max-width: 7%; justify-content: center;">
                                <span class="fix-width">{{ getOTP(element,element.numberOtpRemain) }}</span>
                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 7%; justify-content: center;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>





                        <ng-container matColumnDef="action">
                            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="max-width: 5%;">
                                {{'headertable.action' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                                class="number-cell-center" style="max-width: 5%;">
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon matTooltip="{{'enterprise_contract.buttons.more_icon' | translate}}">
                                        more_vert</mat-icon>
                                </button>

                                <mat-menu #menu="matMenu">
                                    <!-- Nhắc ký hợp đồng văn bản -->
                                    <button mat-menu-item (click)="notifySignContract(element)" [disabled]="element.contractStatus != 2">
                                        <i *ngIf="element.contractStatus == enumContractStatus.PROCESSING"
                                            class="fa fa-bell-o fa-fw vt-cursor-pointer mr-1" aria-hidden="true"
                                            style="color: #DE0D0D;font-size: 1rem;"
                                            matTooltip="{{'enterprise_customer_management.buttons.notify_sign_contract' | translate}}">
                                        </i>
                                        <span>{{'enterprise_customer_management.buttons.notify_sign_contract' |
                                            translate}}</span>
                                    </button>

                                    <!-- Reset OTP -->
                                    <button mat-menu-item (click)="openPDFByBrowser(element)"
                                        [disabled]="commonService.getIsLockedEnterprise() || !element.enableResetOtp">
                                        <mat-icon  class="mr-1">
                                            replay
                                        </mat-icon>
                                        <span class="fix-width">{{'Reset OTP' | translate}}</span>
                                    </button>

                                    <!-- Gửi link hợp đồng -->
                                    <button
                                        mat-menu-item
                                        (click)="sendLinkContract(element.id, element)"
                                        [disabled]="commonService.getIsLockedEnterprise() || !element.isSignNoLogin"
                                    >
                                        <mat-icon class="mr-1">link</mat-icon>
                                        <span>{{'enterprise_contract.buttons.send_link_contract' | translate}}</span>
                                    </button>

                                    <!-- Sao chép link -->
                                    <button mat-menu-item (click)="forwardContract(element)"
                                        [disabled]="commonService.getIsLockedEnterprise() || !element.isSignNoLogin">
                                        <mat-icon class="mr-1">file_copy</mat-icon>
                                        <span class="fix-width">{{'search_form.copy_link' | translate}}</span>
                                    </button>
                                </mat-menu>

                            </mat-cell>
                          <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 5%;">
                              <span class="skeleton-cell"></span>
                          </mat-footer-cell>
                        </ng-container>

                        <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                             ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot; an/hien qua class theo isTableLoading -->
                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
                            [cdkDetailRow]="row" (toggleChange)="onToggleChange($event,row)">
                        </mat-row>
                        <mat-footer-row *matFooterRowDef="displayedColumns"
                                        class="table-skeleton-row"
                                        [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
                    </mat-table>
                </div>

                <!-- Pagination -->
                <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)"
                                [isShowNoRecord]="!isTableLoading">
                </app-pagination>
            </mat-expansion-panel>
        </mat-accordion>


    </mat-card-content>
</mat-card>